<template>
    <nav class="menu-container">

      <RouterLink
        :exact="item.exact"
        v-for="item in items"
        :key="item.link"
        :to="{ name: item.name }"
        active-class="selected"
        exact-active-class=""
      >
        <div class="icon">
          <Icon :type="item.icon" />
        </div>
        <span>{{ item.title }}</span>
      </RouterLink>
      龙园站<br>
站点介绍<br>
龙园站位于龙平东路与龙园路交叉口，沿龙平东路东西向跨路口设置，车站周边主要以居住用地、商业为主。车站设置有3个出入，其中B口有景丰楼、锦盛苑、沃尔玛。C口有福宁小区、上圩小区、平冈中学。D口有龙园公园<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
大运	06:07	23:16	16号线	5分32秒	6分40秒<br>
田心	06:16	23:32	16号线	5分32秒	6分40秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
大运	06:17	23:16	16号线	5分50秒	6分钟-9分钟<br>
田心	06:22	23:32	16号线	5分50秒	6分钟-9分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
大运	06:17	00:16	16号线	5分50秒	6分钟-9分钟<br>
田心	06:22	00:32	16号线	5分50秒	6分钟-9分钟<br><br>

站点出口信息<br><br>
B出入口:<br>
龙平东路南侧（东）、景丰楼、锦盛苑、沃尔玛<br><br>
C出入口:<br>
龙平东路北侧（东）、福宁小区、上圩小区、平冈中学<br><br>
D出入口:<br>
龙平东路北侧（西）、龙园公园<br><br>
公交换乘信息<br><br>
B出入口:<br>
公交站名： 龙园路口<br>
M277、M308、M556<br><br>
C出入口:<br>
公交站名： 龙园公园<br>
358、M556<br><br>
D出入口:<br>
公交站名： 东升学校<br>
M569、358、810、M276、M304、M386<br>
  </nav>
  </template>

  <script>
  // import Icon from "@/components/Icon";
  export default {
    components: {
      // Icon,
    },
    data() {
      return {
        items: [
          {
            name: "shiliuhaoxian",
            title: "16号线",
            // icon: "chat",
            exact: true,
          },
        ],
      };
    },
  };
  </script>

  <style scoped lang="less">
  @import "~@/styles/var.less";
  .menu-container {
    color: @words;
    margin: 24px 0;
    a {
      &.selected {
        background: darken(@words, 3%);
      }
      padding: 0 50px;
      display: block;
      display: flex;
      align-items: center;
      height: 45px;
      // .icon {
      //   width: 24px;
      // }
      &:hover {
        color: rgb(50, 95, 227);
      }
    }
  }
  </style>